import React, { Component } from 'react';
import { Button, Row, Col, Form, Icon, message } from 'antd';
import { connect } from 'react-redux';

import { updateObject } from '../../../shared/utility';

import { auth } from '../../../services/firebase/firebase';
import { loadUserInfo, uploadUserInfo, deleteUserInfo } from '../../../services/firebase/user';
import { loadUserDataAction } from "../../../actions/userStoreActions";

import config from './formConfig';

import Input from '../../../components/UI/Input/Input';
import ImageUpload from '../../../components/Items/ImageUploader';

import InstagramFeed from './InstagramFeed';
import DeleteProfileSection from './DeleteProfileSection';
import MyEvents from './MyEvents';

class InfoAndEventsTab extends Component {
  constructor(props){
    super(props);
    this.state = {
      controls: config,
      thumbnailName: "" ,
      PhotoUrl: "" ,
      isImageDataSent: true
    };

    auth().onAuthStateChanged(user => {
      user && this.props.loadUserDataAction(user.uid)
        .then((userData) => {
          const updatedControls = updateObject(this.state.controls, {
            displayName: updateObject(this.state.controls.displayName, {
              value: (userData && userData.DisplayName) || 'User'
            }),
            instagram: updateObject(this.state.controls.instagram, {
              value: (userData && userData.instagram) || ''
            }),
            email: updateObject(this.state.controls.email, {
              value: (userData && userData.Email) || ''
            }),
            biography: updateObject(this.state.controls.biography, {
              value: (userData && userData.biography) || ''
            })
          });

          this.setState({controls: updatedControls, PhotoUrl: (userData && userData.PhotoUrl) || ''});

          return userData
        })
        .catch((err) => console.error('Error initial profile component', err));

      this.setState({user})
    });
  }

  inputChangeHandler = (event, controlName) => {
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        value: event.target.value,
        touched: true
      })
    });
    this.setState({controls: updatedControls});
  };

  handleUpdateImage(url, thumbnailName) {
    this.setState({
      PhotoUrl: url,
      thumbnailName: thumbnailName,
      isImageDataSent: false,
    })
  };

  async forgotPassword(){
    const { value } = this.state.controls.email;
    if (!value) {
      return message.error('Email field is required');
    }

    auth().sendPasswordResetEmail(value);
    message.success('Email sent');
    this.setState({refresh: Math.random()})
  }

  deleteProfileAccount = (type) => {
    const resetEmailConfirmation = updateObject(this.state.controls, {
      emailConfirmationDeleting: updateObject(this.state.controls.emailConfirmationDeleting, {
        value: ''
      }),
      passwordConfirmationDeleting: updateObject(this.state.controls.passwordConfirmationDeleting, {
        value: ''
      })
    });

    if (type === 'cancel') {
      return this.setState({ controls: resetEmailConfirmation, deleteProfileStage: '' });
    }

    if (type === 'complete') {
      const user = auth().currentUser;
      const { passwordConfirmationDeleting} = this.state.controls;
      const { uid } = user;

      const credential = auth.EmailAuthProvider.credential(
        user.email,
        passwordConfirmationDeleting.value
      );

      return user.reauthenticateAndRetrieveDataWithCredential(credential).then(() => {
        return user.delete().then(() => {
          return deleteUserInfo(uid)
          }).then(() => {
            this.setState({ controls: resetEmailConfirmation, deleteProfileStage: '' });
            this.props.signOut();
            return message.success('Account is deleted successfully');
          });
      }).catch(function(error) {
        console.error('error', error.message);
        message.error(error.message);
      });
    }

    this.setState( state => {
      const { deleteProfileStage } = state;

      let stage;
      if (!deleteProfileStage) {
        stage = 'first'
      }
      if (deleteProfileStage === 'first') {
        const { email, emailConfirmationDeleting, passwordConfirmationDeleting } = state.controls;
        if (email.value !== emailConfirmationDeleting.value && passwordConfirmationDeleting.value) {
          return message.warning('Sorry, the emails do not match or you forgot to enter your password');
        }
        stage = 'second';
      }
      return {
        deleteProfileStage: stage
      }
    });
  };

  uploadInfo(downloadURLProps, thumbnailNameProps){
    const { displayName, email, biography, instagram } = this.state.controls;
    const { PhotoUrl, thumbnailName} = this.state;

    let obj = {
      DisplayName: displayName.value,
      Email: email.value,
      PhotoUrl: PhotoUrl,
      thumbnailName: thumbnailName,
      biography: biography.value,
      instagram: instagram.value,
    };

    if (downloadURLProps && thumbnailNameProps) {
      obj[PhotoUrl] = downloadURLProps;
      obj[thumbnailName] = thumbnailNameProps;

      this.sendInfoUser(obj)
    } else {
      this.sendInfoUser(obj)
    }
  };

  sendInfoUser (obj) {
    const uid = auth().currentUser.uid;

    uploadUserInfo(obj, uid)
      .then(() => loadUserInfo(uid))
      .then(res => {
        message.success('Profile saved');
        this.setState(res);
        this.setState({isImageDataSent: true});
      })
  };

  render() {
    const { userData, userClaims } = this.props.user;
    const { events, ownChannels } = this.props;
    const { instagram, deleteProfileStage } = this.state;

    const formElementsArray = [];
    for (let key in this.state.controls) {
      formElementsArray.push({
        id: key,
        config: this.state.controls[key]
      })
    }

    let form = formElementsArray.map(formElement => (
      <Input
        label={formElement.config.label}
        key={formElement.id}
        icon={formElement.config.icon}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        invalid={!formElement.config.valid}
        changed={(event) => this.inputChangeHandler(event, formElement.id)}
      />
    ));

    return (
      <div className="tab-content">
        <Row className="profile" type="flex" gutter={25}>
          <Col xs={24} md={5} className="profile-avatar">
            <ImageUpload
              className="avatar-uploader"
              uploadText="Add Avatar"
              uploadItemAction={(downloadURL, thumbnailName) => this.uploadInfo(this.state.values, downloadURL, thumbnailName)}
              imageUrl={this.state.PhotoUrl || ''}
              newElement={true}
              thumbnailName={this.state.thumbnailName || ''}
              isImageDataSent={this.state.isImageDataSent}
              onImageUpload={(url, thumbnailName) => this.handleUpdateImage(url, thumbnailName)}
            />
            <Button type="primary" disabled={true}>
              Subscribers: <b>{(userData && userData.subscribers) || '0'}</b>
            </Button>
          </Col>
          <Col xs={24} md={12} className="profile-edit-inputs">
            <Row type="flex" gutter={20}>
              <Col xs={24} md={12}>
                {form.slice(0,1)}
                {/*Display Name*/}
              </Col>
              <Col xs={24} md={12}>
                {form.slice(1,2)}
                {/*Instagram*/}
              </Col>
            </Row>
            <Row type="flex" gutter={20}>
              <Col xs={24} md={12}>
                {form.slice(2,3)}
                {/*Email*/}
              </Col>
              <Col xs={24} md={12}>
                <Form.Item label="Password">
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => this.forgotPassword()}
                  >
                    <Icon type="lock" /> Change Password
                  </Button>
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" gutter={20}>
              <Col xs={24}>
                {form.slice(3,4)}
                {/*Biography*/}
              </Col>
            </Row>

            <Row type="flex" gutter={20}>
              <DeleteProfileSection
                deleteProfileAccount={this.deleteProfileAccount}
                deleteProfileStage={deleteProfileStage}
                form={form}
              />
            </Row>
            <Row type="flex" gutter={20} className="saveChanges-button">
              <Col xs={24}>
                <Button
                  className="btn-success"
                  onClick={() => this.uploadInfo()}
                >
                  Save Changes
                </Button>
              </Col>
            </Row>
            <Row type="flex" gutter={20} className="mobile-logout-button">
              <Col xs={24}>
                <Button
                  className="btn-logout"
                  onClick={() => this.props.signOut()}
                >
                  Log Out
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        <InstagramFeed
          instagram={instagram}
        />

        <MyEvents
          events={events}
          ownChannels={ownChannels}
          userClaims={userClaims}
          location ={this.props.location}
        />
      </div>
    )
  };
}

export default connect(null, { loadUserDataAction })(InfoAndEventsTab);



// WEBPACK FOOTER //
// ./src/pages/MyProfile/InfoAndEventsTab/index.js